import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=7593cdde&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./BannerCarousel.vue?vue&type=style&index=0&id=7593cdde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7593cdde",
  null
  
)

export default component.exports